var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LybIcon",style:({
    width: ("" + _vm.size),
    height: ("" + _vm.size),
    margin: (_vm.top + " " + _vm.right + " " + _vm.bottom + " " + _vm.left),
    backgroundImage: ("url(" + (!_vm.toggle ? _vm.imgUrl : _vm.imgUrlHover || _vm.imgUrl) + ")"),
  }),attrs:{"title":_vm.title},on:{"mouseenter":function($event){_vm.toggle = true},"mouseleave":function($event){_vm.toggle = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }